import { useQuery } from '@tanstack/react-query';

import { setCurrentUser } from '~entities/users/model/user-store';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';

import type { UserWithRole } from '../model/types';
import { AxiosError } from 'axios';

export const getCurrentUserAPI = async () => {
  const response = await baseAPI.get<UserWithRole>(`/users`);
  const user = response.data;
  setCurrentUser(user);
  return response.data;
};

export const useGetCurrentUser = (
  // `retry` kept for call-site API compat (previously gated the 20s poll).
  { retry: _retry = true }: { retry?: boolean } = {},
) => {
  return useQuery({
    queryKey: QUERY_KEYS.CURRENT_USER(),
    queryFn: () => getCurrentUserAPI(),
    retry(_failureCount, error) {
      if (error instanceof AxiosError) {
        if (error.response?.status === 401 || error.response?.status === 403) {
          return false;
        }
      }
      return true;
    },
    // ENR-2522: JWT/role do not need a 20s poll; rely on staleTime + invalidation.
    refetchInterval: false,
  });
};

